/**
 * Controller for LIST view of crop planning
 */
angular
  .module('cfn')
  .controller(
    'cropPlanningOperationController',
    cropPlanningOperationController
  );

cropPlanningOperationController.$inject = [
  '$scope',
  '$rootScope',
  '$log',
  '$http',
  '$timeout',
  '$dialog',
  '$q',
  'i18nFilter',
  'CropPlanningData',
  '$filter',
  'CfnDialogService',
  'googleApi'
];
function cropPlanningOperationController(
  $scope,
  $rootScope,
  $log,
  $http,
  $timeout,
  $dialog,
  $q,
  i18nFilter,
  CropPlanningData,
  $filter,
  CfnDialogService,
  googleApi
) {
  'use strict';
  var controller = this,
    NO_FRUIT = '',
    NO_FRUIT_COLOR = '#cccccc',
    SPLIT_DELIM_CHAR = '|',
    AREA_DECIMALS = 4;

  $scope.cropPlanningController = this;
  $scope.model = {};
  $scope.regularCultureList = [];
  $scope.ueCultureList = [];
  $scope.isEditable = false;
  $scope.saving = false;

  this.multi = { currentFruit: null };
  this.lastAggregatedValues = null;
  this.lastAggregatedVarietyValues = null;
  this.varietyAggr = {};
  this.currentIdNum = 1; // reset own generated ids

  /**
   * Opens detail information on row and selects it in table
   *
   * @param {number} rowDetails index of row to select
   */
  this.selectRow = function(rowDetails) {
    if (!rowDetails) {
      $scope.model = {};
      return;
    }

    $scope.model.id = rowDetails.id;
    $scope.model.rowDetails = rowDetails;

    angular
      .element('#gridCrops')
      .isolateScope()
      .gridController.setSelectedRowById(rowDetails.id);
  };

  /**
   * Sums up float values
   * TODO: Reusable / Extract to a grid tools service?
   */
  this.sum = function(aggregatedValue, currentValue) {
    currentValue += aggregatedValue;
    return currentValue;
  };

  /**
   * Starts the timer to auto save after defined interval
   */
  this.reportChanges = function() {
    $rootScope.preventNavigation();
  };

  /**
   * Determines if this row is an overhang
   */
  this.isOverhang = function(rowDetails) {
    var isNotOverhang = function(rowDetails) {
      var rowInQuestion = rowDetails;

      // Eine Frucht ist der Hauptanbau (= keine Zweitfrucht/Überhang), falls
      // a) sie nicht Anbauart Zwischenfrucht hat
      if (rowInQuestion.sowingType === 'INSIDE_CROP') {
        return false;
      }
      // b) im Erntejahr die Frucht mit dem frühesten Saat-Termin ist
      var earliestDate = null;
      var earliestNotInsideCropRow = null;
      // Earliest seed
      $.each($scope.operation.details, function(k, v) {
        if (v.number !== rowInQuestion.number) {
          return;
        }
        if (
          v.seedDate &&
          (!earliestDate || v.seedDate < earliestDate) &&
          v.sowingType !== 'INSIDE_CROP'
        ) {
          earliestDate = v.seedDate;
          earliestNotInsideCropRow = v.id;
        }
      });
      if (rowDetails.id === earliestNotInsideCropRow) {
        return true;
      }
      // c) falls es noch keine Termine gibt die erste/mit frühestem Erstellungsdatum
      if (!earliestDate) {
        var lowestId = null;
        var lowestIndex = null;
        $.each($scope.operation.details, function(k, v) {
          if (v.number !== rowInQuestion.number) {
            return;
          }
          if (
            (!lowestIndex || k < lowestIndex) &&
            v.sowingType !== 'INSIDE_CROP'
          ) {
            lowestId = v.id;
          }
        });
        if (rowDetails.id === lowestId) {
          return true;
        }
      }
      // If we get here, it is an overhang
      return false;
    };
    return !isNotOverhang(rowDetails);
  };

  /**
   * Checks if there is another field with the same field number
   * (overhang)
   */
  this.hasOverhang = function(row) {
    var rowInQuestion = row;
    var otherFieldWithSameNumberFound = false;
    $.each($scope.operation.details, function(k, v) {
      // Same field?
      if (v.id === row.id) return;

      if (v.number === rowInQuestion.number) {
        otherFieldWithSameNumberFound = true;
        return false;
      }
    });
    return otherFieldWithSameNumberFound;
  };

  /**
   * Unselect current operation and return to intro page
   */
  this.chooseCropYear = function() {
      $rootScope.goto('analyse/cropoverview');
  };

  /**
   * Hide details part
   */
  this.hideDetails = function() {
    if ($scope.model.origRowDetails) {
      $scope.model.rowDetails = $scope.model.origRowDetails;
      $scope.grid.selected = {}; // Object! not Array!
    }
    controller.selectRow();
  };

  // Table
  this.refreshTableData = function() {
    // Skip if grid not fully initialized
    if (
      angular.element('#gridCrops').isolateScope() &&
      angular.element('#gridCrops').isolateScope().updateModel
    ) {
      // Update whole grid
      angular
        .element('#gridCrops')
        .isolateScope()
        .updateModel();
    }
  };

  /**
   * Resize table to make it render correctly.
   * Is called each time the table is shown.
   */
  this.onShowTable = function() {
    $log.debug('onShowTable()');
    controller.currentTab = 0;
    ang.callAfter(function() {
      // Make sure grid has a height assigned
      $rootScope.window.forceResize();
    });
  };

  /**
   * Resize table the first time it is shown to make it render correctly
   * TODO: Is this watching more than once since unwatching is disabled?
   */
  $scope.$watch('operation.id', function(newValue, oldValue) {
    if (newValue !== oldValue) {
      controller.onShowTable();
    }
  });

  /**
   * Called when the user clicks on a table cell
   */
  this.onGridCellClick = function(columnName, rowData) {
    controller.selectRow(rowData);
  };

  /**
   * Called when a feature has been selected on map
   *
   * @param {object} event
   * @param {string} id uuid of the selected field
   */
  this.onSelectFeature = function(event, id) {
    $log.debug('onSelectFeature ' + id);
    ang.apply($scope, function() {
      var row = null;
      $.each($scope.operation.details, function(k, v) {
        if (v.id === id) {
          row = v;
          return false;
        }
      });
      if (row !== null) {
        controller.selectRow(row);
      } else {
        $log.warn('Selected feature not found');
      }
    });
  };

  /**
   * Returns if given details row is visualized in real area graph
   */
  this.countsAsRealArea = function(detailsRow) {
    // MAIN_CROP always counts to real area, even if it is actually an overhang (second main crop per harvest year)
    return (
      !detailsRow.isOverhang ||
      detailsRow.sowingType === 'MAIN_CROP' ||
      detailsRow.sowingType === 'CATCH_CROP' ||
      detailsRow.sowingType === 'PERMANENT_CROP'
    );
  };

  /**
   * Returns if given details row is visualized in overhang graph
   */
  this.countsAsOverhang = function(detailsRow) {
    return detailsRow.isOverhang;
  };

  /**
   * Helper function to accumulate cultures for chart
   * @param {object} accumulation of cultures
   * @param {object} details row to add
   */
  this.addToAggregate = function(fruitBag, v) {
    var fruitId = v.abbrFruit ? v.abbrFruit.id : NO_FRUIT;
    // Create an entry for the culture if not present
    if (!(fruitId in fruitBag)) {
      fruitBag[fruitId] = {
        displayName: v.abbrFruit.abbrFruit, // v.abbrFruit.name + ' ['+v.abbrFruit.abbrFruit+']',
        color: v.abbrFruit.colour,
        farmedArea: 0.0
      };
    }
    fruitBag[fruitId].farmedArea += v.farmedArea;
  };

  /**
   * Helper function that generates an aggregated statistic of cultures
   */
  this.aggregateCultures = function() {
    var fruitAggr = {},
      fruitAggrOverhang = {};
    fruitAggr[NO_FRUIT] = {
      displayName: i18nFilter('fe.planning.cropplanning.withoutCulture'),
      color: NO_FRUIT_COLOR,
      farmedArea: 0.0
    };
    fruitAggrOverhang[NO_FRUIT] = {
      displayName: i18nFilter('fe.planning.cropplanning.withoutCulture'),
      color: NO_FRUIT_COLOR,
      farmedArea: 0.0
    };

    $.each($scope.operation.details, function(k, detailsRow) {
      // Sort into real area and/or overhang
      if (controller.countsAsRealArea(detailsRow)) {
        controller.addToAggregate(fruitAggr, detailsRow);
      }
      if (controller.countsAsOverhang(detailsRow)) {
        controller.addToAggregate(fruitAggrOverhang, detailsRow);
      }
    });

    return {
      regular: fruitAggr,
      overhang: fruitAggrOverhang
    };
  };

  /**
   * Draws a chart of planned cultures
   *
   * @param {object} culturesChart chart object to update
   * @param {object} cultureAggr data source, map of aggregated culture information
   * @param {object} cultureMap target array that saves index => culture ID (optional)
   * @param {string} chartTitle caption of chart (optional)
   * @param {string} highlightCulture UUID of culture to highlight in the chart (optional)
   * @param {object} chartOptions additional options for chart (e.g. legend)*
   */
  this.drawCulturesChart = function(
    culturesChart,
    cultureAggr,
    cultureMap,
    chartTitle,
    highlightCulture,
    chartOptions,
    selectable
  ) {
    if (cultureMap) {
      // clear array
      cultureMap.length = 0;
    }
    var series = [];
    $.each(cultureAggr, function(cultureId, v) {
      if (v.farmedArea > 0) {
        var curOb = {
          name: v.displayName,
          y: preciseRound(v.farmedArea, AREA_DECIMALS),
          sliced: false,
          color: v.color
        };
        series.push(curOb);
        var slice = { color: v.color };
        // Highlight current fruit
        if (cultureId === highlightCulture) {
          slice.offset = 0.2;
          curOb.sliced = true;
        }
        if (cultureMap) {
          cultureMap.push(cultureId);
        }
      }
    });
    this.drawPieChart(culturesChart, series, chartTitle, selectable);
  };

  /**
   * Draws a pie chart via highcharts
   * @param {object} jquery element target
   * @param {string} cultureId UUID or NO_FRUIT
   * @param {boolean} overhang if true, only overhang is shown, else only regular crop
   * @param {string} chartTitle caption of chart
   * @param {object} chartOptions additional options for chart (e.g. legend)
   */
  this.drawPieChart = function(chart, series, chartTitle, selectable) {
    if (!chart) {
      // don't draw anything if element is not selected
      return;
    }
    var ctrl = this,
      colors = [];
    for (var i = 0; i < series.length; i++) {
      colors.push(series[i].color ? series[i].color : '#ccc');
      // Delete original colors, so that new radialized are used
      delete series[i].color;
    }
    // Use color array and radialize each color
    var radientColors = Highcharts.map(colors, function(color) {
      return {
        linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
        stops: [
          [0, color],
          [
            1,
            Highcharts.Color(color)
              .brighten(-0.1)
              .get('rgb')
          ] // darken
        ]
      };
    });
    chart.highcharts({
      chart: {
        backgroundColor: 'rgba(255,255,255,0.002)',
        plotBorderWidth: null,
        plotShadow: true,
        spacing: [1, 1, 1, 1],
        stickyTracking: true
      },
      title: { text: '' },
      tooltip: {
        followPointer: false,
        pointFormat: '<b>{point.y:.4f} ha</b>'
      },
      legend: {
        padding: 4,
        backgroundColor: '#FFFFFF'
      },
      plotOptions: {
        pie: {
          allowPointSelect: selectable,
          cursor: 'pointer',
          colors: radientColors,
          startAngle: 90,
          showInLegend: true,
          slicedOffset: 4,
          events: {
            click: function(event) {
              if (selectable) {
                ctrl.onCultureChartSelect(chart, event.point.x);
              }
            }
          },
          dataLabels: {
            backgroundColor: 'rgba(255,255,255,0.5)',
            inside: true,
            distance: 10,
            enabled: true,
            color: '#000000',
            connectorColor: '#cccccc',
            style: 'text-align:center',
            format: '<b>{point.name}</b><br>{point.y:.2f}ha'
          }
        }
      },
      credits: { enabled: false },
      series: [
        {
          type: 'pie',
          name: 'Anteil',
          data: series
        }
      ]
    });
  };

  /**
   * aggregate varieties
   */
  this.aggrVarieties = function(cultureId, overhang) {
    controller.varietyAggr = {};
    var noFruit = {
      displayName: i18nFilter('fe.planning.cropplanning.unplanned'),
      cropArea: 0,
      color: '#ccc'
    };
    $.each($scope.operation.details, function(k, detail) {
      // Show either only regular or only overhang
      if (
        (overhang && !controller.countsAsOverhang(detail)) ||
        (!overhang && !controller.countsAsRealArea(detail))
      ) {
        return;
      }
      // Does culture match or are we regarding fields without fruit?
      if (
        (detail.abbrFruit && detail.abbrFruit.id === cultureId) ||
        (!detail.abbrFruit && cultureId === NO_FRUIT)
      ) {
        var varietySum = 0;
        if (detail.varietyDetails) {
          $.each(detail.varietyDetails, function(vk, varietyDetail) {
            // This happens temporary
            if (!varietyDetail.variety || !varietyDetail.variety.sysSeed) {
              return;
            }
            if (!(varietyDetail.variety.id in controller.varietyAggr)) {
              controller.varietyAggr[varietyDetail.variety.id] = {
                displayName: varietyDetail.variety.name,
                cropArea: 0.0,
                color: varietyDetail.variety.colour
              };
            }
            var aggrRow = controller.varietyAggr[varietyDetail.variety.id];
            aggrRow.cropArea += varietyDetail.cropArea;
            varietySum += varietyDetail.cropArea;
          });
        }
        if (varietySum < detail.farmedArea) {
          noFruit.cropArea += detail.farmedArea - varietySum;
        }
      }
    });
    if (noFruit.cropArea > 0) {
      controller.varietyAggr[NO_FRUIT] = noFruit;
    }
  };

  /**
   * Draws a variety chart
   * @param {object} seedChart chart object to update
   * @param {string} cultureId UUID or NO_FRUIT
   * @param {boolean} overhang if true, only overhang is shown, else only regular crop
   * @param {string} chartTitle caption of chart
   * @param {object} chartOptions additional options for chart (e.g. legend)
   */
  this.drawVarietyChart = function(seedChart, chartTitle) {
    var series = [];
    $.each(controller.varietyAggr, function(varietyId, variety) {
      var curOb = {
        name: variety.displayName,
        y: preciseRound(variety.cropArea, AREA_DECIMALS),
        sliced: false,
        color: variety.color
      };
      series.push(curOb);
    });
    this.drawPieChart(seedChart, series, chartTitle, false);
  };

  this.updateCharts = function() {
    if (!$scope.operation || !controller.cultureAggr) {
      return;
    }
    var options = { legend: { position: 'right' } };
    // Regular crop
    controller.drawCulturesChart(
      controller.chartRegularCulture,
      controller.cultureAggr.regular,
      $scope.regularCultureList,
      i18nFilter('fe.planning.cropplanning.statistics.cultureRegularArea'),
      null,
      options,
      true
    );
    // Overhang
    controller.drawCulturesChart(
      controller.chartOverhangCulture,
      controller.cultureAggr.overhang,
      $scope.ueCultureList,
      i18nFilter('fe.planning.cropplanning.statistics.cultureOverhang'),
      null,
      options,
      true
    );
  };

  this.updateDetailCharts = function() {
    if (!$scope.model.rowDetails || !controller.cultureAggr) {
      return;
    }
    var selectedCultureId = $scope.model.rowDetails.abbrFruit
      ? $scope.model.rowDetails.abbrFruit.id
      : NO_FRUIT;
    var updateCulturesChart = function() {
      var chartOptions = { legend: { position: 'top', maxLines: 5 } };
      controller.drawCulturesChart(
        controller.chartSelectedFruit,
        controller.cultureAggr.regular,
        $scope.ueCultureList,
        i18nFilter('fe.common.culture_plural'),
        selectedCultureId,
        chartOptions,
        false
      );
    };
    var updateVarietiesChart = function() {
      var chartOptions = { legend: { position: 'top', maxLines: 5 } };
      var chartTitle = i18nFilter('fe.planning.cropplanning.varieties');
      if ($scope.model.rowDetails.abbrFruit) {
        chartTitle += ' ' + $scope.model.rowDetails.abbrFruit.abbrFruit;
      }
      //aht: add check if its overhand on row select
      controller.drawVarietyChart(
        controller.chartSelectedFruitVarietys,
        chartTitle,
        chartOptions
      );
    };
    var updateOverhangChart = function() {
      var physicalCropArea = 0;
      var overhangArea = 0;
      $.each($scope.operation.details, function(k, v) {
        if (v.isOverhang) {
          overhangArea += v.farmedArea;
        } else {
          physicalCropArea += v.farmedArea;
        }
      });
      var series = [
        {
          name: i18nFilter('fe.planning.cropplanning.cropArea'),
          data: [preciseRound(physicalCropArea, AREA_DECIMALS)]
        },
        {
          name: i18nFilter('fe.planning.cropplanning.overhang_ha'),
          data: [preciseRound(overhangArea, AREA_DECIMALS)]
        }
      ];
      if (!controller.chartOverhangRatio) {
        return;
      }
      controller.chartOverhangRatio.highcharts({
        chart: {
          type: 'bar',
          backgroundColor: 'rgba(255,255,255,0.5)'
        },
        title: { text: '' },
        xAxis: { categories: [''] },
        yAxis: {
          min: 0,
          title: { text: '' }
        },
        credits: { enabled: false },
        legend: {
          verticalAlign: 'top',
          floating: true,
          padding: 4,
          backgroundColor: '#FFFFFF',
          reversed: true
        },
        tooltip: {
          followPointer: false,
          headerFormat: '',
          pointFormat: '{point.y:.4f} ha'
        },
        plotOptions: { series: { stacking: 'normal' } },
        series: series
      });
    };
    updateCulturesChart();
    updateVarietiesChart();
    updateOverhangChart();
  };

  $scope.isMultiSelected = function() {
    return $scope.grid && $scope.grid.count > 1;
  };

  $scope.isElementRO = function() {
    if (
      $scope.model &&
      $scope.model.rowDetails &&
      $scope.model.rowDetails.invalid
    ) {
      return true;
    }
    if (
      $scope.operation &&
      ($scope.operation.activity === 'SCN_TRANS' ||
        $scope.operation.activity === 'OVERVIEW')
    ) {
      return true;
    }
    return !!(
      $scope.model &&
      $scope.model.rowDetails &&
      $scope.model.rowDetails.readOnlyFruit
    );
  };

  /**
   * Init charts
   */
  ang.tryUntilTrue(function() {
    controller.chartOverhangSeed = $('#chartOverhangSeed');
    // after the GEA Merge with 2.12 the simple timeout did not work anymore and we had to resort to this helper function.
    if (controller.chartOverhangSeed.length === 0) {
      return false;
    }
    controller.chartRegularCulture = $('#chartRegularCulture');
    controller.chartRegularSeed = $('#chartRegularSeed');
    controller.chartOverhangCulture = $('#chartOverhangCulture');
    controller.chartSelectedFruit = $('#chartSelectedFruit');
    controller.chartSelectedFruitVarietys = $('#chartSelectedFruitVarietys');
    controller.chartOverhangRatio = $('#chartOverhangRatio');
    controller.updateCharts();
    controller.updateDetailCharts();
    return true;
  });

  /**
   * Called if user selects a culture in crop relation chart
   *
   * @param {boolean} overhang true to update overhang chart, else main crop chart
   */
  this.onCultureChartSelect = function(chart, selectedItem) {
    var cultureList,
      seedChart,
      chartTitle,
      regularCultureChart = chart.attr('id') === 'chartRegularCulture',
      chartOverhangCulture = chart.attr('id') === 'chartOverhangCulture',
      overhang = chartOverhangCulture;
    if (!regularCultureChart && !chartOverhangCulture) {
      return;
    }
    if (regularCultureChart) {
      cultureList = $scope.regularCultureList;
      seedChart = controller.chartRegularSeed;
      chartTitle = i18nFilter(
        'fe.planning.cropplanning.statistics.seedRegularArea'
      );
    } else {
      cultureList = $scope.ueCultureList;
      seedChart = controller.chartOverhangSeed;
      chartTitle = i18nFilter(
        'fe.planning.cropplanning.statistics.seedOverhang'
      );
    }

    if (seedChart) {
      if (selectedItem >= 0) {
        var cultureId = cultureList[selectedItem];
        controller.aggrVarieties(cultureId, overhang);
        controller.drawVarietyChart(seedChart, chartTitle, {});
      } else {
        while (seedChart.series.length > 0) {
          seedChart.series[0].remove(true);
        }
      }
    }
  };

  /**
   * Called each time statistics are show
   */
  this.onShowStatistics = function() {
    controller.currentTab = 2;
    controller.hideDetails();
    controller.updateCharts();
  };

  /**
   * Watch for changes in selected row and show appropriate details
   * Heads up: Does not work if index show to a different row but didn't change
   * (e.g. deleting or added rows)
   */
  $scope.$watch(
    'model.rowDetails',
    function(newValue, oldValue) {
      // Show details only if a row is selected
      $rootScope.window.displayRight = newValue !== undefined;
      if (newValue === oldValue) {
        return;
      }
      $scope.isEditable = !(
        $scope.operation && $scope.operation.activity === 'SCN_TRANS'
      );
      $scope.model.rowDetails = newValue !== undefined ? newValue : undefined;
      // Deep scan for changes
      if (
        oldValue &&
        newValue &&
        oldValue.id === newValue.id &&
        $scope.operation.activity !== 'OVERVIEW'
      ) {
        $.each(oldValue, function(k, v) {
          if (newValue[k] !== v) {
            controller.reportChanges();
            return false;
          }
          if (v instanceof Array) {
            $.each(v, function(k1, v1) {
              if (newValue[k][k1] !== v1) {
                controller.reportChanges();
                return false;
              }
            });
          }
        });
      }
      //update sumPlannedArea
      if (newValue) {
        $scope.model.rowDetails.sumPlannedArea = 0;
        if (newValue.varietyDetails) {
          $.each(newValue.varietyDetails, function(k, v) {
            $scope.model.rowDetails.sumPlannedArea += v.cropArea;
          });
        }
      }
      if ($scope.model.rowDetails) {
        if (
          $scope.grid > 1 &&
          $scope.model.rowDetails.varietyDetails &&
          $scope.model.rowDetails.varietyDetails[0]
        ) {
          $scope.model.rowDetails.varietyDetails[0].cropArea =
            $scope.model.selectedSumFieldArea;
        }
        if (
          $scope.model.rowDetails.farmedArea &&
          $scope.model.rowDetails.sumPlannedArea
        ) {
          $scope.model.diffFarmedArea = preciseRound(
            $scope.model.rowDetails.farmedArea,
            AREA_DECIMALS
          );
          $scope.model.rowDetails.sumPlannedArea = preciseRound(
            $scope.model.rowDetails.sumPlannedArea,
            AREA_DECIMALS
          );
        }
        var selectedCultureId = $scope.model.rowDetails.abbrFruit
          ? $scope.model.rowDetails.abbrFruit.id
          : NO_FRUIT;
        controller.aggrVarieties(
          selectedCultureId,
          $scope.model.rowDetails.isOverhang
        );
      } else {
        controller.aggrVarieties(NO_FRUIT, null);
      }
      controller.validateChartUpdate();
    },
    true
  );

  /**
   * validate if chart update is needed
   */
  this.validateChartUpdate = function() {
    var updated = false;
    controller.cultureAggr = controller.aggregateCultures();
    $.each(controller.cultureAggr, function(listType, list) {
      $.each(list, function(k) {
        if (
          !controller.lastAggregatedValues ||
          !controller.lastAggregatedValues[listType][k] ||
          controller.lastAggregatedValues[listType][k].farmedArea !==
            controller.cultureAggr[listType][k].farmedArea
        ) {
          controller.updateTableAndCharts();
          controller.lastAggregatedValues = controller.cultureAggr;
          updated = true;
        }
      });
    });
    if (!updated && controller.varietyAggr) {
      $.each(controller.varietyAggr, function(k, v) {
        if (
          !controller.lastAggregatedVarietyValues ||
          !controller.lastAggregatedVarietyValues[k] ||
          controller.lastAggregatedVarietyValues[k].cropArea !== v.cropArea
        ) {
          controller.updateTableAndCharts();
          controller.lastAggregatedVarietyValues = controller.varietyAggr;
        }
      });
    }
  };

  /**
   * This function is called to notify that table and charts need to be updated.
   * The update however does not happen immediatelly to batch changes.
   *
   * @param {boolean} force update has to happen immediatelly
   */
  this.updateTableAndCharts = function(force) {
    $log.debug('delayed update');
    var doUpdate = function() {
      $log.debug('actual update');
      controller.refreshTableData();
      controller.updateDetailCharts();
    };
    if (force) {
      ang.clearTimeout(controller, 'delayUpdate');
      doUpdate();
    } else {
      ang.delayedTimeout(controller, 'delayUpdate', doUpdate, 200);
    }
  };

  /**
   * Watch for all detail model changes and update calculated fields
   */
  $scope.$watch(
    'operation.details',
    function(newValue, oldValue) {
      if (!newValue) {
        return;
      }
      $log.debug('update calculated fields');
      $scope.sumFieldArea = 0;
      $scope.hasCorn = false;
      $.each($scope.operation.details, function(index, value) {
        // Rows without id are new fields. In crop overview, this is the regular case.
        if (value.id === null && $scope.operation.activity !== 'OVERVIEW') {
          controller.reportChanges();
        }
        // Virtual name (Actually backend should do this..)
        if (value.number === null) {
          value.number = value.field.number;
        }
        // Sum of planned revenues
        value.sumPlannedResults = 0;
        value.sumPlannedArea = 0;
        value.firstHarvestUnit = null;
        value.firstVariety = null;
        value.firstSeedStrength = null;
        value.aggregateVariety = null;
        if (value.varietyDetails && value.varietyDetails.length > 0) {
          // Unit of first selected harvest
          var variety = value.varietyDetails[0];
          value.firstHarvestUnit = variety.harvestUnit;
          if (variety.variety) {
            value.firstVariety = variety.variety.name;
          } else {
            variety.firstVariety = {};
          }
          value.firstSeedStrength = variety.seedStrenght;
          var largestVariety = undefined;
          var largestVarietyArea = 0;
          // Aggreates
          $.each(value.varietyDetails, function(vk, vv) {
            if (
              $.isNumeric(vv.plannedResults) &&
              vv.harvestUnit &&
              value.firstHarvestUnit
            ) {
              //convert units
              var sumValueResults = parseFloat(vv.plannedResults * vv.cropArea);
              var fromUnit = vv.harvestUnit.toLowerCase();
              var toUnit = value.firstHarvestUnit.toLowerCase();
              // Try to add harvest amount to the sum. If a unit cannot be converted, it is not added
              if (fromUnit && toUnit) {
                value.sumPlannedResults += $filter('unitConverter')(
                  sumValueResults,
                  fromUnit,
                  toUnit
                );
              } else {
                value.sumPlannedResults += parseFloat(
                  vv.plannedResults * vv.cropArea
                );
              }
            }
            if ($.isNumeric(vv.cropArea)) {
              var cropArea = parseFloat(vv.cropArea);
              value.sumPlannedArea += cropArea;
              if (
                largestVariety === undefined ||
                cropArea > largestVarietyArea
              ) {
                largestVariety = vv;
                largestVarietyArea = cropArea;
              }
            }
          });
          // Show first variety and the count of other varieties
          if (largestVariety && largestVariety.variety) {
            value.aggregateVariety = largestVariety.variety.name;
          }
          if (value.varietyDetails.length > 1) {
            value.aggregateVariety +=
              ' (+' + (value.varietyDetails.length - 1) + ')';
          }
          // Show planned results, but per area
          value.sumPlannedResults /= value.sumPlannedArea;
        }
        // Is this row an overhang?
        value.isOverhang = controller.isOverhang(value);
        // Does an overhang exist for this row?
        value.hasOverhang = value.isOverhang
          ? false
          : controller.hasOverhang(value);
        var farmedArea = value.farmedArea;
        if (value.farmedArea) {
          farmedArea = preciseRound(value.farmedArea, AREA_DECIMALS);
        }
        value.invalid = value.field.invalid; // !value.farmedArea;
        if (!value.isOverhang) {
          $scope.sumFieldArea += value.farmedArea;
        }
        $scope.operation.details[index] = value;
      });
      if (
        $scope.model.rowDetails &&
        $scope.model.rowDetails.farmedArea &&
        $scope.model.rowDetails.sumPlannedArea
      ) {
        $scope.model.diffFarmedArea = preciseRound(
          $scope.model.rowDetails.farmedArea,
          AREA_DECIMALS
        );
        $scope.model.rowDetails.sumPlannedArea = preciseRound(
          $scope.model.rowDetails.sumPlannedArea,
          AREA_DECIMALS
        );
      }
      controller.validateChartUpdate();
      $scope.grid = angular.element('#gridCrops').isolateScope(); //important for watching on multiple selected rows
    },
    true
  );

  $scope.$watch(
    'grid.selected',
    function(newValue) {
      if (!newValue) {
        return;
      }
      //init
      $scope.grid.count = 0;
      $scope.model.selectedSumFieldArea = 0;
      //loop through selected rows
      for (var i in newValue) {
        if (newValue[i].invalid && $scope.grid && $scope.grid.count > 1) {
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter(
              'fe.cropPlanning.multiselection.rowInvalid',
              'Invalide Schläge können nicht aufgenommen werden.'
            ),
            'error'
          );
          delete $scope.grid.selected[i];
          return;
        }
        //set current fruit
        if ($scope.grid.count === 0) {
          controller.multi.currentFruit = newValue[i].abbrFruit;
          //set default rowdetails to first selected row
          //to display details window
          $scope.model.id = i;
          $scope.model.origRowDetails = newValue[i];
          $scope.model.rowDetails = $.extend(true, {}, newValue[i]);
          if (
            $scope.model.rowDetails.varietyDetails &&
            $scope.model.rowDetails.varietyDetails.length > 1
          ) {
            var veraties = $scope.model.rowDetails.varietyDetails;
            $scope.model.rowDetails.varietyDetails = [];
            $scope.model.rowDetails.varietyDetails.push(veraties[0]);
          }
        }
        $scope.grid.count++;
        //first selected row defines the current fruit
        //validate if fruit equals current fruit
        if (
          (newValue[i].abbrFruit &&
            controller.multi.currentFruit &&
            newValue[i].abbrFruit.id === controller.multi.currentFruit.id) ||
          newValue[i].abbrFruit === controller.multi.currentFruit
        ) {
          $scope.model.selectedSumFieldArea += newValue[i].farmedArea;
        } else if (
          newValue[i].abbrFruit &&
          controller.multi.currentFruit &&
          newValue[i].abbrFruit.id === controller.multi.currentFruit.id
        ) {
          $scope.model.selectedSumFieldArea += newValue[i].farmedArea;
        } else {
          //remove row from selected list if current fruit doesn't match
          $scope.grid.count--;
          delete $scope.grid.selected[i];
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter(
              'fe.cropPlanning.multiselection.noEqualFruit',
              'Der ausgewählte Schlag enthält eine andere Frucht. Neur Schläge mit gleicher Frucht können ausgewähkt werden.'
            ),
            'warn'
          );
        }
      }
      if (
        $scope.grid.count > 1 &&
        $scope.model.rowDetails.varietyDetails[0] !== undefined
      ) {
        $scope.model.rowDetails.varietyDetails[0].cropArea =
          $scope.model.selectedSumFieldArea;
      }
      if ($scope.grid.count === 1) {
        $scope.model.rowDetails = $scope.model.origRowDetails;
      }
      if ($scope.grid.count === 0) {
        $scope.model = {};
      }
      controller.refreshTableData();
    },
    true
  );

  this.goBackToCore = function(obType) {
    $rootScope.allowNavigation();
    app.gotoWithBackButton(
      'core/' + obType,
      '/planning/cropplanning',
      i18nFilter('fe.cropPlanning.back', 'zurück zur Anbauplanung'),
      'cropPlanningController',
      {
        model: $scope.model,
        operation: $scope.operation
      }
    );
  };

  $scope.operation = app.farmnetControllers.data;

  if (
    $rootScope.goBackState &&
    $rootScope.goBackState.type === 'cropPlanningController'
  ) {
    $scope.operation = $rootScope.goBackState.data.operation;
    $scope.model = $rootScope.goBackState.data.model;
    ang.callAfter(function() {
      $scope.isEditable = !(
        $scope.operation && $scope.operation.activity === 'SCN_TRANS'
      );
      $scope.grid = angular.element('#gridCrops').isolateScope();
      angular
        .element('#gridCrops')
        .isolateScope()
        .gridController.setSelectedRowById($scope.model.id);
    });
    $rootScope.alertController.addTemporaryAlert(
      i18nFilter(
        'fe.cropPlanning.continue.message',
        'Anbauplanung wird fortgesetzt'
      ),
      'success'
    );
    $rootScope.goBackState = null; // i did go back !
    $rootScope.window.displayRight = true;
  } else {
    $scope.operation = app.farmnetControllers.data;
  }

  if ($scope.operation == null || $scope.operation.details == null) {
    $log.error('Neither scenario ID nor crop overview year given');
  }
  return this;
}
